<template>
    <div class="creator-name-container">
        <div class="creator-name-container__avatar">
            <img v-if="userinfo.avatars" :src="userinfo.avatars.default.url" />
            <UserOutIcon v-else width="108" fill="white" />
        </div>
        <div
            v-if="userinfo.username"
            class="creator-name-container__name"
            :title="userinfo.username"
        >
            Hello, {{ croppName(userinfo.username, 15) }}!
        </div>
        <div
            v-if="userinfo.profile.username"
            class="creator-name-container__nickname"
            :title="userinfo.profile.username"
        >
            @{{ userinfo.profile.username }}
        </div>
    </div>
</template>

<script>
import User from '@/services/user';
import { croppName } from '@/lib/croppName.js';

//SVG
import UserOutIcon from 'Svgs/user_out.svg?inline';

export default {
    name: 'DashboardCreatorName',
    components: { UserOutIcon },
    data() {
        return {
            userinfo: { profile: {} },
        };
    },
    mounted() {
        this.getUserInfo();
    },
    methods: {
        croppName,
        getUserInfo() {
            User.getUser()
                .then(response => {
                    this.userinfo = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },
    },
};
</script>

<style scoped lang="scss">
.creator-name-container {
    display: grid;
    grid-template-columns: 35% 1fr;
    width: auto;
    height: 223px;
    margin-top: 3.6rem;
    background-color: #0e2d4e;
    opacity: 0.96;
    @media (max-width: $lg-up) {
        display: none;
    }

    &__avatar {
        grid-column: 1 / 2;
        justify-self: right;
        margin-top: 4rem;
    }
    &__name {
        grid-row-start: 1;
        grid-column: 2 / 3;
        margin: 4rem auto auto 3rem;
        color: #ffffff;
        font-family: $politica-font;
        font-size: 37px;
        font-weight: 700;
        letter-spacing: 2.04px;
        line-height: 60px;
    }
    &__nickname {
        grid-row: 1;
        grid-column: 2 / 3;
        margin: 7rem auto auto 10rem;
        max-width: 320px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #ffffff;
        font-family: $istok-font;
        font-size: 23px;
        max-height: 53px;
        font-weight: 400;
        letter-spacing: 0.46px;
        line-height: 53px;
    }
}
</style>
